/* eslint-disable max-classes-per-file */
import { CommonService } from '@Services/common.service'

class MAmmunitionTransactionDetail {
    address: string

    city: string

    country: string

    phone: string

    salesRep: string

    state: string

    zipCode: string

    businessName: string

    constructor(transactionDetail: MAmmunitionTransactionDetail) {
        this.address = transactionDetail?.address || ' - '
        this.city = transactionDetail?.city || ' - '
        this.country = transactionDetail?.country || ' - '
        this.phone = transactionDetail?.phone || ' - '
        this.salesRep = transactionDetail?.salesRep || ' - '
        this.state = transactionDetail?.state || ' - '
        this.zipCode = transactionDetail?.zipCode || ' - '
        this.businessName = transactionDetail?.businessName || ' - '
    }
}

export class MAmmunition {
    make: string

    name: string

    caliber: string

    fflId: string

    qty: string

    qmicrostamp: string

    madeAt: string

    transactionDetail: any

    id: string

    constructor(ammunition: any) {
        this.make = ammunition?.make?.code || ' - '
        this.name = ammunition?.make?.name || ' - '
        this.caliber = ammunition?.caliber || ' - '
        this.fflId = ammunition?.fflId || ' - '
        this.qty = ammunition?.qty || ' - '
        this.qmicrostamp = ammunition?.qmicrostamp || ' - '
        this.madeAt =
            ammunition?.madeAt || ' - '
                ? CommonService.dateFormat(ammunition?.madeAt)
                : ' - '
        this.transactionDetail = new MAmmunitionTransactionDetail(
            ammunition?.transactionDetail
        )
        this.id = ammunition?.id || ' - '
    }
}
